import { SpeakerWaveIcon, SpeakerXMarkIcon } from '@heroicons/react/24/solid';
import { MediaMuteButton } from 'media-chrome/react';

import { HeroIcon } from '@/components/atoms/Icon';

import { defaultButtonStyling } from './util';

export function PlayerMuteButton() {
  return (
    <MediaMuteButton
      className="flex-none text-(--player-text-color-primary) bg-white"
      style={defaultButtonStyling}
    >
      <span slot="high">
        <HeroIcon icon={SpeakerWaveIcon} />
      </span>
      <span slot="medium">
        <HeroIcon icon={SpeakerWaveIcon} />
      </span>
      <span slot="low">
        <HeroIcon icon={SpeakerWaveIcon} />
      </span>
      <span slot="off">
        <HeroIcon icon={SpeakerXMarkIcon} />
      </span>
    </MediaMuteButton>
  );
}
